














import { defineComponent, PropType } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'Review',
  props: {
    reviews: {
      type: Array as PropType<{ quote: string, who: string }[]>,
      default: () => [],
      required: true,
    },
  },
});
